import React from 'react'
import { Tooltip } from '@progress/kendo-react-tooltip'
import './buttonTrashHLPure.css'

/**
 * @typedef {Object} Props
 * @property {Number} openDelay Time in ms to show. Default 600
 * @property {Function} onClickBtn Function 
 * @param {Props}
 * @return {JSX.Element} 
 */
const ButtonTrashHLPure = ({ openDelay = 600, onClickBtn }) => {
  return (
    <div>
      <Tooltip
        openDelay={openDelay}
        position='top'
        anchorElement='target'
        tooltipClassName='tooltipGeneralStyle'
      >
        <button
          className='buttonTrashHLPure-btn'
          onClick={onClickBtn}
        >
          <i
            className='k-icon k-i-delete k-i-trash'
          ></i>
        </button>
      </Tooltip>
    </div>
  )
}

export { ButtonTrashHLPure as default }